export default __webpack_public_path__ + "static/media/pp-b-4.d125e8ee.svg";